export default __webpack_public_path__ + "static/media/icon_views-2.404d5ad3.svg";